module.exports = __webpack_public_path__ + "static/media/icon_info_inactive_light.244b93f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_info_inactive_light.png
// module id = 518
// module chunks = 0